import React, { useEffect, useState, useCallback } from "react";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";

import {
  Container,
  Content,
  Title,
  Field,
  Input,
  Label,
  FaixaPreview,
  ButtonFaixa,
  DataContainer,
} from "./styles";
// importação dos componente para o preview
import {
  ContainerTimer,
  ContainerFlip,
  FlipUnitContainerStyle,
  FlipDigitContainerStyle,
} from "../Criar/styles";

import { getUserNode } from "../../../../services/auth_node";
import { producaov2 as api } from "../../../../services/apis";

import { withRouter } from "react-router-dom";

import { Button, Checkbox, Icon, Form, Dropdown } from "semantic-ui-react";
import swal from "sweetalert";
import { isAuthAdmin } from "../../../../services/auth";

const FlipUnitContainer = ({
  digit,
  unit,
  backgroundColor,
  colorUnit,
  color,
}) => {
  const currentDigit = digit.toString();

  return (
    <FlipUnitContainerStyle colorUnit={colorUnit}>
      <p>{unit}</p>
      <FlipDigitContainerStyle backgroundColor={backgroundColor} color={color}>
        <span>{currentDigit}</span>
      </FlipDigitContainerStyle>
    </FlipUnitContainerStyle>
  );
};

const FaixasEditar = (props) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [active, setActive] = useState(false);
  const [enunciado, setEnunciado] = useState("");
  const [enunciadoBotao, setEnunciadoBotao] = useState("");
  const [link, setLink] = useState("");
  const [corFundoFaixa, setCorFundoFaixa] = useState("#000");
  const [corFundoBotao, setCorFundoBotao] = useState("#f2711c");
  const [corFaixa, setCorFaixa] = useState("#fff");
  const [corBotao, setCorBotao] = useState("#fff");

  const [timerActive, setTimerActive] = useState(false);
  const [corTimerUnit, setCorTimerUnit] = useState("#fff");
  const [corTimerDigit, setCorTimerDigit] = useState("#a0f");
  const [corBackgroundTimer, setCorBackgroundTimer] = useState("#ccc");
  const [dataTimer, setDataTimer] = useState(new Date());

  const [temTimer, setTemTimer] = useState(false);

  const [diaArr, setDiaArr] = useState([]);
  const [horArr, setHorArr] = useState([]);
  const [minArr, setMinArr] = useState([]);

  const [mesFinal, setMesFinal] = useState(new Date().getMonth());
  const [anoFinal, setAnoFinal] = useState(new Date().getFullYear());

  const mesArr = [
    { key: "1", text: "Janeiro", value: "0" },
    { key: "2", text: "Fevereiro", value: "1" },
    { key: "3", text: "Março", value: "2" },
    { key: "4", text: "Abril", value: "3" },
    { key: "5", text: "Maio", value: "4" },
    { key: "6", text: "Junho", value: "5" },
    { key: "7", text: "Julho", value: "6" },
    { key: "8", text: "Agosto", value: "7" },
    { key: "9", text: "Setembro", value: "8" },
    { key: "10", text: "Outubro", value: "9" },
    { key: "11", text: "Novembro", value: "10" },
    { key: "12", text: "Dezembro", value: "11" },
  ];

  const anoArr = [
    {
      key: "1",
      text: new Date().getFullYear(),
      value: new Date().getFullYear(),
    },
    {
      key: "2",
      text: new Date().getFullYear() + 1,
      value: new Date().getFullYear() + 1,
    },
    {
      key: "3",
      text: new Date().getFullYear() + 2,
      value: new Date().getFullYear() + 2,
    },
    {
      key: "4",
      text: new Date().getFullYear() + 3,
      value: new Date().getFullYear() + 3,
    },
  ];

  useEffect(() => {
    loadAuth();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  useEffect(() => {
    let i = 0;
    let arrHor = [];
    for (i = 0; i < 24; i++) {
      arrHor.push({ key: i + 1, text: i, value: i });
    }
    setHorArr(arrHor);

    let arrMin = [];
    for (i = 0; i < 60; i++) {
      arrMin.push({ key: i + 1, text: i, value: i });
    }
    setMinArr(arrMin);
  }, [temTimer]);

  useEffect(() => {
    if (timerActive) {
      setTemTimer(true);
    }
  }, [timerActive]);

  useEffect(() => {
    setDiaArr(getDaysInMonth(mesFinal, anoFinal));
  }, [mesFinal, anoFinal, temTimer]);

  const getDaysInMonth = useCallback((month, year) => {
    let date = new Date(year, month, 1);
    let days = [];
    let i = 0;
    while (date.getMonth() === month) {
      days.push({ key: i + 1, text: new Date(date).getDate(), value: i + 1 });
      date.setDate(new Date(date.getDate() + 1));
      i++;
    }
    return days;
  });

  const id = props.history.location.pathname.split("/").pop();

  const loadFaixas = useCallback(() => {
    api
      .get(`faixas/${id}`)
      .then((res) => {
        const {
          enunciado,
          enunciado_botao,
          cor_faixa,
          cor_botao,
          cor_fundo_faixa,
          cor_fundo_botao,
          link,
          active,
          cor_timer_unit,
          cor_timer_digit,
          cor_timer_box,
          timer_active,
          data_limite_timer,
        } = res.data;

        setEnunciado(enunciado);
        setEnunciadoBotao(enunciado_botao);
        setLink(link);
        setCorFaixa(cor_faixa);
        setCorBotao(cor_botao);
        setCorFundoFaixa(cor_fundo_faixa);
        setCorFundoBotao(cor_fundo_botao);
        setCorTimerUnit(cor_timer_unit);
        setCorTimerDigit(cor_timer_digit);
        setCorBackgroundTimer(cor_timer_box);
        setDataTimer(new Date(data_limite_timer));
        setTimerActive(timer_active);
        setActive(active);
      })
      .catch((err) => {
        console.error(err);
        swal(
          "Requisição mal sucedida",
          "Não foi possível pegar as faixas",
          "error"
        );
      });
  }, [id]);

  useEffect(() => {
    if (!getUserNode().admin) {
      props.history.push("/login");
      return;
    }

    loadFaixas();

    setIsAdmin(true);
  }, []);

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();

      api
        .put(`faixas/${id}`, {
          enunciado,
          enunciado_botao: enunciadoBotao,
          link,
          cor_faixa: corFaixa,
          cor_botao: corBotao,
          cor_fundo_faixa: corFundoFaixa,
          cor_fundo_botao: corFundoBotao,

          cor_timer_unit: corTimerUnit,
          cor_timer_digit: corTimerDigit,
          cor_timer_box: corBackgroundTimer,
          timer_active: timerActive,
          data_limite_timer: dataTimer,

          active,
        })
        .then((res) => {
          console.log(res);
          let array = { local: "faixas", texto: `editou a faixa de id=${id}` };
          api.post("system_logs", { acao: JSON.stringify(array) });
          swal(
            "Requisição bem sucedida",
            "Faixa criado com sucesso",
            "success"
          );
        })
        .catch((err) => {
          console.error(err);
          swal(
            "Requisição mal sucedida",
            "Não foi possível efetuar a criação de faixa",
            "error"
          );
        });
    },
    [
      enunciado,
      enunciadoBotao,
      link,
      corFaixa,
      corBotao,
      corFundoFaixa,
      corFundoBotao,
      active,
      corBackgroundTimer,
      corTimerDigit,
      corTimerUnit,
      timerActive,
      dataTimer,
    ]
  );

  if (!isAdmin) {
    return null;
  }

  return (
    <Container>
      <AdminMenu />

      <Content>
        <Title>Criar faixa fixa para o site</Title>

        <Form onSubmit={handleSubmit}>
          <Field>
            <Label>Enunciado</Label>
            <Input
              value={enunciado}
              onChange={(e) => setEnunciado(e.target.value)}
            />
          </Field>

          <Field>
            <Label>Enunciado Botão</Label>
            <Input
              value={enunciadoBotao}
              onChange={(e) => setEnunciadoBotao(e.target.value)}
            />
          </Field>

          <Field>
            <Label>Link</Label>
            <Input value={link} onChange={(e) => setLink(e.target.value)} />
          </Field>

          <Field>
            <Label>Cor do Texto da Faixa</Label>
            <Input
              value={corFaixa}
              onChange={(e) => setCorFaixa(e.target.value)}
            />
          </Field>

          <Field>
            <Label>Cor do Fundo da Faixa</Label>
            <Input
              value={corFundoFaixa}
              onChange={(e) => setCorFundoFaixa(e.target.value)}
            />
          </Field>

          <Field>
            <Label>Cor do Texto do Botao</Label>
            <Input
              value={corBotao}
              onChange={(e) => setCorBotao(e.target.value)}
            />
          </Field>

          <Field>
            <Label>Cor do Fundo do Botao</Label>
            <Input
              value={corFundoBotao}
              onChange={(e) => setCorFundoBotao(e.target.value)}
            />
          </Field>

          <Field>
            <Checkbox
              label="Cronômetro"
              checked={temTimer}
              onChange={(e) => setTemTimer(!temTimer)}
            />
          </Field>

          {temTimer ? (
            <div>
              <Field>
                <Label>Data Final</Label>
                <DataContainer>
                  <Dropdown
                    defaultValue={dataTimer.getDate()}
                    placeholder="Dia"
                    selection
                    search
                    options={diaArr}
                    onChange={(e, value) => {
                      setDataTimer(
                        new Date(dataTimer.setDate(parseInt(value.value)))
                      );
                    }}
                  />
                  <Dropdown
                    defaultValue={mesArr[dataTimer.getMonth()].value}
                    placeholder="Mês"
                    selection
                    search
                    options={mesArr}
                    onChange={(e, value) => {
                      setMesFinal(parseInt(value.value));
                      setDataTimer(
                        new Date(dataTimer.setMonth(parseInt(value.value)))
                      );
                    }}
                  />
                  <Dropdown
                    defaultValue={dataTimer.getFullYear()}
                    placeholder="Ano"
                    selection
                    search
                    options={anoArr}
                    onChange={(e, value) => {
                      setAnoFinal(parseInt(value.value));
                      setDataTimer(
                        new Date(dataTimer.setFullYear(parseInt(value.value)))
                      );
                    }}
                  />
                </DataContainer>

                <DataContainer>
                  <Dropdown
                    defaultValue={dataTimer.getHours()}
                    placeholder="Hora"
                    selection
                    search
                    options={horArr}
                    onChange={(e, value) => {
                      setDataTimer(
                        new Date(dataTimer.setHours(parseInt(value.value)))
                      );
                    }}
                  />
                  <Dropdown
                    defaultValue={dataTimer.getMinutes()}
                    placeholder="Minuto"
                    selection
                    search
                    options={minArr}
                    onChange={(e, value) => {
                      setDataTimer(
                        new Date(dataTimer.setMinutes(parseInt(value.value)))
                      );
                    }}
                  />
                  <Dropdown
                    defaultValue={dataTimer.getSeconds()}
                    placeholder="Segundo"
                    selection
                    search
                    options={minArr}
                    onChange={(e, value) => {
                      setDataTimer(
                        new Date(dataTimer.setSeconds(parseInt(value.value)))
                      );
                    }}
                  />
                </DataContainer>
              </Field>

              <Field>
                <Label>Cor da unidade</Label>
                <Input
                  value={corTimerUnit}
                  onChange={(e) => setCorTimerUnit(e.target.value)}
                />
              </Field>

              <Field>
                <Label>Cor dos digitos</Label>
                <Input
                  value={corTimerDigit}
                  onChange={(e) => setCorTimerDigit(e.target.value)}
                />
              </Field>

              <Field>
                <Label>Cor de fundo do timer</Label>
                <Input
                  value={corBackgroundTimer}
                  onChange={(e) => setCorBackgroundTimer(e.target.value)}
                />
              </Field>

              <Field>
                <Checkbox
                  label="Cronômetro - Ativo"
                  checked={timerActive}
                  onChange={(e) => setTimerActive(!timerActive)}
                />
              </Field>
            </div>
          ) : null}

          <Field>
            <Checkbox
              label="Ativo"
              checked={active}
              onChange={(e) => setActive(!active)}
            />
          </Field>

          <h3>Preview:</h3>
          <FaixaPreview
            href={link}
            target="_blank"
            color={corFaixa}
            backgroundColor={corFundoFaixa}
          >
            <p>{enunciado}</p>
            {temTimer ? (
              <ContainerTimer>
                <ContainerFlip colorUnit={corTimerUnit}>
                  <FlipUnitContainer
                    backgroundColor={corBackgroundTimer}
                    colorUnit={corTimerUnit}
                    color={corTimerDigit}
                    unit={"Dias"}
                    digit={"1"}
                  />{" "}
                  <span> : </span>
                  <FlipUnitContainer
                    backgroundColor={corBackgroundTimer}
                    colorUnit={corTimerUnit}
                    color={corTimerDigit}
                    unit={"Horas"}
                    digit={"19"}
                  />{" "}
                  <span> : </span>
                  <FlipUnitContainer
                    backgroundColor={corBackgroundTimer}
                    colorUnit={corTimerUnit}
                    color={corTimerDigit}
                    unit={"Min"}
                    digit={"55"}
                  />{" "}
                  <span> : </span>
                  <FlipUnitContainer
                    backgroundColor={corBackgroundTimer}
                    colorUnit={corTimerUnit}
                    color={corTimerDigit}
                    unit={"Seg"}
                    digit={"12"}
                  />
                </ContainerFlip>
              </ContainerTimer>
            ) : null}
            <ButtonFaixa
              color={corBotao}
              backgroundColor={corFundoBotao}
              onClick={(e) => {
                e.preventDefault();
                window.open(link);
              }}
            >
              {enunciadoBotao}
            </ButtonFaixa>
          </FaixaPreview>

          <ButtonFaixa color={"black"}>
            <Icon name="user plus" /> Salvar
          </ButtonFaixa>
        </Form>
      </Content>
    </Container>
  );
};

export default withRouter(FaixasEditar);
